import angular from 'angular';
import StoreFeaturesComponent from './store-features.component';

let StoreFeaturesModule = angular.module('home.storeFeatures',[])
    .component('storeFeatures',StoreFeaturesComponent);

export default StoreFeaturesModule;


/** WEBPACK FOOTER **
 ** ./www/components/shared/components/store-features/store-features.js
 **/